import './App.css';
import './assets/styles/main.scss';
import React, { useState, useEffect } from 'react';
import withAuthProvider from './components/auth/AuthProvider';
import { Layout } from './components/Layout';
import RoutesStore from './Routes';
import { Provider } from '@fluentui/react-northstar';
import { BrowserRouter } from 'react-router-dom';
import { WindowProvider, WindowContext } from './components/shared/contexts/Context';
import { useTeams } from './components/shared/customhooks';
import AccountService from './components/services/accountservice';
import MonitoringService from './components/services/monitoringservice';

const App = (props) => {
  const [loaded, setLoaded] = useState(false);
  const [DefaultCustomers, SetDefaultCustomers] = useState({});
  const [loggedinPermissionGroupName, SetLoggedinPermissionGroupName] = useState("");
  const [restrictedAccess, SetRestrictedAccess] = useState("0");
  const [monitoringHome, setMonitoringHome] = React.useState(null);

  // const [infraIncidentsIsRefresh, setinfraIncidentsIsRefresh] = React.useState(false);
  // const [dataIncidentsIsRefresh, setdataIncidentsIsRefresh] = React.useState(false);
  // const [serviceIncidentsIsRefresh, setserviceIncidentsIsRefresh] = React.useState(false);
  // const [dbMonitoringIncidentsIsRefresh, setdbMonitoringIncidentsIsRefresh] = React.useState(false);
  // const [provisioningIncidentsIsRefresh, setprovisioningIncidentsIsRefresh] = React.useState(false);

  useEffect(() => {
    // debugger
    if (global.localStorage) {
      global.localStorage.removeItem('contentUrl_dashboards');
    }
    props.acquireToken((token) => {
      // debugger
      AccountService.GetAccountPermissions(token).then((response) => {
        // debugger
        if(response){
          props.updateUser(response);
         
        }
        setLoaded(true);
      });
    });

    updateIncidentsCount();

    // const interval = setInterval(() => {
    //   updateIncidentsCount();
    // }, 600000 );

  }, []);

  useEffect(() => {
    // debugger
    if(!props.isAuthenticated){
      props.updateUser(null);
    }
  }, [props.isAuthenticated]);

  useEffect(() => {
    // debugger
    props.acquireToken((token) => {
      // debugger
      AccountService.GetUserDetails(token).then((response) => {
        // debugger
        if(response){
          SetDefaultCustomers(response.RestrictedCustomers);
          SetLoggedinPermissionGroupName(response.PermissionGroupName);
          SetRestrictedAccess(response.RestrictedAccess);
        }
        setLoaded(true);
      });
    });
  }, []);




  const updateIncidentsCount = () => {
    props.acquireToken((token) => {
      // console.log('test44343');
      if (token) {
        MonitoringService.GetMonitoringHome(token).then((response) => {
          if(response && response.status==200){
            response=response.data;
            setMonitoringHome(response);
          }
        });
      }
    });  
  }

  const pgLoadMethods = () => {
    
    props.acquireToken((token) => {
      // debugger
      AccountService.GetAccountPermissions(token).then((response) => {
        // debugger
        if(response){
          props.updateUser(response);
         
        }
        setLoaded(true);
      });
    });    
  }

// Polling logic
useEffect(() => {
  const interval = setInterval(() => {
    if (!loaded && props.user == null) {
      pgLoadMethods();
    }
  }, 30000); // Poll every 1 seconds

  // Cleanup interval on component unmount or when loaded
  return () => clearInterval(interval);
}, [loaded,props.user]);

  useEffect(()=>{
    console.log(loaded);
    console.log(props.user);
  },[loaded, props.user]);

  // const updateinfraIncidentsIsRefresh = () => {
  //   setinfraIncidentsIsRefresh(true);
  // }

  // const updatedataIncidentsIsRefresh = () => {
  //   setdataIncidentsIsRefresh(true);
  // }
  // const updateserviceIncidentsIsRefresh = () => {
  //   setserviceIncidentsIsRefresh(true);
  // }
  // const updatedbMonitoringIncidentsIsRefresh = () => {
  //   setdbMonitoringIncidentsIsRefresh(true);
  // }
  // const updateprovisioningIncidentsIsRefresh = () => {
  //   setprovisioningIncidentsIsRefresh(true);
  // }


  return (
    <BrowserRouter>
      <WindowProvider>
        <WindowContext.Consumer>
          {(context) =>
            <Provider theme={context.teams.theme} className='main-container'>   
                <Layout {...props} inTeams={context.teams.inTeams} isLocal={context.constants.ISLOCAL}
                 themeHandler={context.teams.setTheme} themeString={context.teams.themeString} viewStatus={context.viewStatus}>
                { 
                  loaded && props.user ? 
                  <RoutesStore {...props} viewStatus={context.viewStatus} isLocal={context.constants.ISLOCAL} 
                   defaultCustomers={DefaultCustomers} loggedinPermissionGroupName={loggedinPermissionGroupName} 
                   restrictedAccess={restrictedAccess} monitoringHome={monitoringHome} updateIncidentsCount={updateIncidentsCount}
                  //  infraIncidentsIsRefresh={infraIncidentsIsRefresh} updateinfraIncidentsIsRefresh={updateinfraIncidentsIsRefresh}
                  //  dataIncidentsIsRefresh={dataIncidentsIsRefresh} updatedataIncidentsIsRefresh={updatedataIncidentsIsRefresh}
                  //  serviceIncidentsIsRefresh={serviceIncidentsIsRefresh} updateserviceIncidentsIsRefresh={updateserviceIncidentsIsRefresh}
                  //  dbMonitoringIncidentsIsRefresh={dbMonitoringIncidentsIsRefresh} updatedbMonitoringIncidentsIsRefresh={updatedbMonitoringIncidentsIsRefresh}
                  //  provisioningIncidentsIsRefresh={provisioningIncidentsIsRefresh} updateprovisioningIncidentsIsRefresh={updateprovisioningIncidentsIsRefresh}
                   /> :
                  <p>Loading...</p>
                }
                </Layout>
            </Provider>
          }
        </WindowContext.Consumer>
      </WindowProvider>   
    </BrowserRouter>  
  );
}


export default withAuthProvider(App);
